// Utilitários de estilo compartilhados pelos componentes de integrações
// (catálogo, detalhe, instalação). Portados verbatim de
// `preview/features/easydental-integration/utils.ts` — feature code não pode
// depender de `preview/`, então a implementação vive aqui a partir da Task 23.
import { useMantineColorScheme, useMantineTheme } from "@mantine/core";
import type { IntegrationCategory } from "../types";

export function useInputStyles() {
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return {
    input: {
      backgroundColor: isDark ? theme.colors["D500"][0] : "#fff",
      color: isDark ? theme.colors["L100"][0] : theme.colors["D900"][0],
      borderColor: isDark ? theme.colors["D400"][0] : theme.colors["L500"][0],
    },
    label: {
      color: isDark ? theme.colors["L100"][0] : theme.colors["D900"][0],
      fontWeight: 600,
    },
    description: {
      color: isDark ? theme.colors["L700"][0] : theme.colors["L750"][0],
    },
  };
}

/** Rótulos e ordem de exibição das categorias do catálogo (mesma forma do preview). */
export const CATEGORY_LABELS: Record<IntegrationCategory, string> = {
  saude: "Saúde",
  agendamento: "Agendamento",
  crm: "CRM",
  produtividade: "Produtividade",
};

export const CATEGORY_ORDER: IntegrationCategory[] = [
  "saude",
  "agendamento",
  "crm",
  "produtividade",
];
